
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicFilesUpload.vue"
}
